import React from "react";
import UnifiedContactModal from "./UnifiedContactModal";

/**
 * BientotModal — PRD 25/02/2026
 * ------------------------------------------------------------------
 * Adaptateur fin : conserve son contrat d'API historique (props ville,
 * deptCode, deptName, source, kind) et son comportement d'ouverture
 * automatique sur les pages « bientôt ». Le moteur de formulaire est
 * délégué à UnifiedContactModal en mode `city` + `cityContext.bientotMode`.
 *
 * Toutes les fonctionnalités historiques sont préservées :
 *  - Couronne 👑 + titre "Bientôt"
 *  - Message "La page dédiée à {ville} arrive très prochainement"
 *  - Capture email + visitor_ville + visitor_departement
 *  - Variante couleur verte pour kind="energ"
 *  - Confettis à la soumission réussie
 *  - Lien vers /annuaire (voyance ou énergétique)
 *  - Payload backend inchangé (POST /api/leads/villes-bientot avec
 *    email, ville, departement_code, departement_name, source,
 *    visitor_ville, visitor_departement)
 */
const BientotModal = ({
  open,
  onClose,
  ville = "",
  deptCode = "",
  deptName = "",
  source = "modal-bientot",
  kind = "voyance",
}) => {
  const annuaireHref = kind === "energ"
    ? `/annuaire?cat=energ${deptCode ? `&dept=${deptCode}` : ""}`
    : `/annuaire?cat=div${deptCode ? `&dept=${deptCode}` : ""}`;

  return (
    <UnifiedContactModal
      open={open}
      onClose={onClose}
      initialType="city"
      prefill={{ ville, departement: deptName || deptCode }}
      cityContext={{
        bientotMode: true,
        targetVille: ville,
        deptCode,
        deptName,
        source,
        kind,
        annuaireHref,
      }}
    />
  );
};

export default BientotModal;
